import type {
  FetchCoachmarksDefaultAction,
  FetchCoachmarksFulfilledAction,
  FetchCoachmarksRejectedAction,
} from "entities/coachmarks/actionTypes";
import { CoachmarkEntityActionType } from "entities/coachmarks/actionTypes";

export const fetchCoachmarks = (): FetchCoachmarksDefaultAction => ({
  type: CoachmarkEntityActionType.FETCH,
});

export const fetchCoachmarksSuccess = (
  payload: FetchCoachmarksFulfilledAction["payload"],
): FetchCoachmarksFulfilledAction => ({
  type: CoachmarkEntityActionType.FETCH_FULFILLED,
  payload,
});

export const fetchCoachmarksFailure = (): FetchCoachmarksRejectedAction => ({
  type: CoachmarkEntityActionType.FETCH_REJECTED,
});
